import { render, staticRenderFns } from "./ModuleUpdateConfig.vue?vue&type=template&id=c77e48ea&scoped=true&"
import script from "./ModuleUpdateConfig.vue?vue&type=script&lang=js&"
export * from "./ModuleUpdateConfig.vue?vue&type=script&lang=js&"
import style0 from "./ModuleUpdateConfig.vue?vue&type=style&index=0&id=c77e48ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77e48ea",
  null
  
)

export default component.exports